module.exports = __webpack_public_path__ + "img/3.c640be3c.png";